import { useState } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { Reveal, Overline } from "./Reveal";
import { PRODUCTS, waLink } from "../../data/site";
import { PurchaseModal } from "./PurchaseModal";

export const Products = () => {
    const [selected, setSelected] = useState(null);
    return (
        <section
            id="katalog"
            data-testid="products"
            className="border-t border-border bg-surface/30"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36">
                <div className="text-center max-w-2xl mx-auto mb-20">
                    <Reveal>
                        <Overline>Katalog Produk</Overline>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.02]">
                            Pilih astana idaman anda.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-5 text-ink-soft">
                            Tiga pilihan untuk setiap keperluan &amp; bajet. Tempah terus
                            menerusi WhatsApp — kami bantu dari A hingga Z.
                        </p>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {PRODUCTS.length === 0 && (
                        <Reveal className="lg:col-span-3">
                            <div
                                data-testid="products-empty"
                                className="border border-dashed border-border bg-bg px-8 py-20 text-center"
                            >
                                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">
                                    Katalog Akan Datang
                                </span>
                                <h3 className="mt-4 font-display text-3xl md:text-4xl text-ink tracking-tight">
                                    Produk sedang dikemas kini.
                                </h3>
                                <p className="mt-3 mx-auto max-w-md text-ink-soft">
                                    Buat masa ini belum ada produk dipaparkan. Hubungi kami
                                    di WhatsApp untuk katalog terkini &amp; sebut harga.
                                </p>
                                <a
                                    href={waLink("Hai ASTANA KUCING'S, boleh kongsikan katalog produk terkini?")}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="products-empty-wa"
                                    className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-accent px-7 py-3.5 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300"
                                >
                                    <WhatsappLogo size={18} weight="fill" />
                                    Minta Katalog
                                </a>
                            </div>
                        </Reveal>
                    )}
                    {PRODUCTS.map((p, i) => (
                        <Reveal key={i} delay={i * 0.1}>
                            <div
                                data-testid={`product-${i}`}
                                className={`group relative flex flex-col border border-border bg-bg h-full overflow-hidden ${
                                    p.featured ? "ring-1 ring-accent/40" : ""
                                }`}
                            >
                                {p.featured && (
                                    <span className="absolute top-4 right-4 z-10 rounded-full bg-accent px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white">
                                        Paling Popular
                                    </span>
                                )}
                                {p.poster ? (
                                    <div className="relative overflow-hidden bg-white">
                                        <img
                                            src={p.image}
                                            alt={`Sangkar kucing ${p.model} ASTANA KUCING'S — ${p.label}`}
                                            loading="lazy"
                                            className="block w-full h-auto group-hover:scale-[1.03] transition-transform duration-[900ms]"
                                        />
                                    </div>
                                ) : (
                                    <div className="relative overflow-hidden aspect-[4/5]">
                                        <img
                                            src={p.image}
                                            alt={`Sangkar kucing ${p.model} ASTANA KUCING'S — ${p.label}`}
                                            loading="lazy"
                                            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-[900ms]"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-bg/50 to-transparent" />
                                    </div>
                                )}

                                <div className="flex items-center justify-between gap-4 p-6 border-t border-border mt-auto">
                                    <div className="min-w-0">
                                        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">
                                            {p.model}
                                        </div>
                                        <div className="mt-1 text-sm text-ink">{p.label}</div>
                                        <div className="text-sm font-semibold text-ink-soft">{p.price}</div>
                                        <div className="mt-2 text-xs text-ink-soft/80 leading-snug">
                                            Deposit 50% masa order, baki semasa penghantaran.
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setSelected(p)}
                                        data-testid={`product-wa-${i}`}
                                        className="shrink-0 inline-flex items-center gap-2 rounded-full bg-accent px-5 py-3 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300"
                                    >
                                        <WhatsappLogo size={18} weight="fill" />
                                        Tempah
                                    </button>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>

            <PurchaseModal
                product={selected}
                open={!!selected}
                onClose={() => setSelected(null)}
            />
        </section>
    );
};
